class Player {
	static DeploymentTypes = {
		Cloud: {val: 1, name: "Cloud"},
		Edge: {val: 7, name: "Edge"},
		Astrum: {val: 8, name: "Astrum"}
	}

	static PurposeTypes = {
		Invalid: {val: 0, name: "Invalid"},
		Primary: {val: 1, name: "Primary"},
		Hotspare: {val: 2, name: "Hotspare"},
		Anonymous: {val: 3, name: "Anonymous"}
	};

	static AlertModes = {
		Off: {val: 0, Off: "Off", color: "green"},
		On: {val: 1, name: "On", color: "red"}
	};
}

export default Player;